<template>
  <b-alert :show="showAlert" :variant="variant" class="alert-container w-100">
    <div class="alert-content">
      <font-awesome-icon :icon="{ prefix: 'fas', iconName: iconName }" class="icon-alert" />
      <div class="alert-text__detail">
        <strong>{{ title }}</strong>
        <p class="m-0 p-0">{{ description }}</p>
      </div>
    </div>
  </b-alert>
</template>

<script>
import {
  faCircleCheck,
  faTimesCircle,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCircleCheck, faTimesCircle, faCircleExclamation);

export default {
  components: { FontAwesomeIcon },
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    alertType: {
      type: String,
      default: 'info'
    }
  },
  computed: {
    iconName() {
      switch (this.alertType) {
        case 'info':
          return 'circle-check';
        case 'warning':
          return 'circle-exclamation';
        default:
          return 'times-circle';
      }
    },
    variant() {
      switch (this.alertType) {
        case 'info':
          return 'info';
        case 'warning':
          return 'warning';
        default:
          return 'danger';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-container {
  margin: 0;
}
.alert-content {
  display: flex;
  gap: 20px;
}

.icon-alert {
  font-size: 20px;
  padding-top: 4px;
}
</style>
